module.exports = __webpack_public_path__ + "img/smart.e79848ad.png";